export default "__VITE_ASSET__CHE9Fo2P__";